import { apiUrls } from 'consts'
import getAll from 'utils/getAll'
import Store from 'redux/Store'
import { setFilterValues } from 'redux/actions'

const getFilterValues = async (id: number) => {
    
    // check if filter values already saved
    let storedFilterValues = Store.getState().filterValues?.filterValues
    let filterValues;
    
    if ((typeof storedFilterValues === 'undefined') || (typeof storedFilterValues[id] === 'undefined')) {

        const filterValuesUrl = apiUrls.actionGetFilterValues + '?id=' + id
        const loadedFilterValues = await getAll(filterValuesUrl)

        // save to store, get fresh store state
        let newFilterValues = Store.getState().filterValues?.filterValues
        newFilterValues[id] = loadedFilterValues

        const res = Store.dispatch(setFilterValues(newFilterValues))
        filterValues = loadedFilterValues
    }
    else {
        filterValues = storedFilterValues[id]
    }
    
    return filterValues
}

export default getFilterValues